export type ShoppingTotalMetricsValueObject = {
    totalAnswerSuccessCount: bigint,
    totalAnswerFailureCount: bigint,
    totalPostBackSuccessCount: bigint,
    totalReportCount: bigint,
    totalAmountCount: bigint,
}

export namespace ShoppingTotalMetricsValueObject {
    export function construct(o: any): ShoppingTotalMetricsValueObject {

        return {
            totalAnswerSuccessCount: BigInt(o.totalAnswerSuccessCount),
            totalAnswerFailureCount: BigInt(o.totalAnswerFailureCount),
            totalPostBackSuccessCount: BigInt(o.totalPostBackSuccessCount),
            totalReportCount: BigInt(o.totalReportCount),
            totalAmountCount: BigInt(o.totalAmountCount),
        }
    }

    export const description: Record<keyof ShoppingTotalMetricsValueObject, string> = {
        totalAnswerSuccessCount: '총 정답 성공 횟수',
        totalAnswerFailureCount: '총 정답 실패 횟수',
        totalPostBackSuccessCount: '총 정답 포스트백 성공 수',
        totalReportCount: '총 상품 신고 수',
        totalAmountCount: '총 유입 수',
    }
}